import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const fallbackPageDefaultVariants = {}
const fallbackPageCompoundVariants = []

const fallbackPageSlotNames = [
  [
    "root",
    "fallbackPage__root"
  ],
  [
    "contentsWrapper",
    "fallbackPage__contentsWrapper"
  ],
  [
    "graphic",
    "fallbackPage__graphic"
  ],
  [
    "textWrapper",
    "fallbackPage__textWrapper"
  ],
  [
    "text",
    "fallbackPage__text"
  ],
  [
    "title",
    "fallbackPage__title"
  ],
  [
    "description",
    "fallbackPage__description"
  ],
  [
    "actions",
    "fallbackPage__actions"
  ]
]
const fallbackPageSlotFns = /* @__PURE__ */ fallbackPageSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, fallbackPageDefaultVariants, getSlotCompoundVariant(fallbackPageCompoundVariants, slotName))])

const fallbackPageFn = memo((props = {}) => {
  return Object.fromEntries(fallbackPageSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const fallbackPageVariantKeys = []
const getVariantProps = (variants) => ({ ...fallbackPageDefaultVariants, ...compact(variants) })

export const fallbackPage = /* @__PURE__ */ Object.assign(fallbackPageFn, {
  __recipe__: false,
  __name__: 'fallbackPage',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: fallbackPageVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, fallbackPageVariantKeys)
  },
  getVariantProps
})